import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [{
		path: '/',
		//redirect: '/index',///:lang?
		component: () => import('../views/index.vue')
	},
	{
		path: '/:lang?/index',
		name: 'index',
		component: () => import('../views/index.vue')
	},
	{
	  path: '/:lang?/register',
	  name: 'Register',
	  component: () => import( '../views/register.vue')
	},
	{
	  path: '/:lang?/registerComplete',
	  name: 'registerComplete',
	  component: () => import( '../views/registerComplete.vue')
	},
	{
	  path: '/:lang?/forgot',
	  name: 'Forgot',
	  component: () => import( '../views/forgot.vue')
	},
	{
	  path: '/:lang?/recorderCloud',
	  name: 'RecorderCloud',
	  component: () => import( '../views/recorderCloud.vue')
	},
	{
	  path: '/:lang?/recorderDetails',
	  name: 'RecorderDetails',
	  component: () => import( '../views/recorderDetails.vue')
	},
	{
	  path: '/:lang?/accountSecurity',
	  name: 'AccountSecurity',
	  component: () => import( '../views/accountSecurity.vue')
	},
	{
	  path: '/:lang?/personalCenter',
	  name: 'PersonalCenter',
	  component: () => import( '../views/personalCenter.vue')
	},
	{
	  path: '/:lang?/updateTrans',
	  name: 'UpdateTrans',
	  component: () => import( '../views/updateTrans.vue')
	},
	{
	  path: '/:lang?/updateSummary',
	  name: 'UpdateSummary',
	  component: () => import( '../views/updateSummary.vue')
	},
	{
	  path: '/:lang?/mapFull',
	  name: 'MapFull',
	  component: () => import( '../views/mapFull.vue')
	}
]

const router = new VueRouter({
	mode: 'history',
	base: '/', // 确保与Nginx配置中的子目录一致
	routes
})

router.beforeEach((to, from, next) => {
	const lang = to.params.lang;
	if (lang && process.env.NODE_ENV === 'production') {
		router.app.$options.i18n.locale = lang;
		localStorage.setItem('lang', lang);
		next();
	} else {
		next();
	}
});

//解决点击重复的path报错问题
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
	//console.log("路由信息",to);
	document.body.scrollTop = 0;
	document.documentElement.scrollTop = 0;
	return VueRouterPush.call(this, to).catch(err => err)
}
export default router